import { render, staticRenderFns } from "./VisitorDetail.vue?vue&type=template&id=560c9ede&scoped=true"
import script from "./VisitorDetail.vue?vue&type=script&lang=js"
export * from "./VisitorDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitorDetail.vue?vue&type=style&index=0&id=560c9ede&prod&lang=scss"
import style1 from "./VisitorDetail.vue?vue&type=style&index=1&id=560c9ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c9ede",
  null
  
)

export default component.exports